import { createAction, props } from '@ngrx/store';
import { AdCategories } from '../../models/ad-categories.model';

export const loadCategories = createAction('[Categories] Load Categories');

export const loadCategoriesSuccess = createAction(
  '[Categories] Load Categories Success',
  props<{ categories: AdCategories }>()
);

export const loadCategoriesFailure = createAction(
  '[Categories] Load Categories Failure',
  props<{ error: any }>()
);

export const alreadyLoaded = createAction('[Categories] Already Loaded');
